/* eslint-disable */
import { callStatic, ReviewsSummaryResponse } from 'services/api-service'

/**
 *
 *
 * @method
 * @name ApiService#reviewsSummary
 * @param {string} sku -
 */
function reviewsSummary(parameters: { sku: string }): Promise<ReviewsSummaryResponse> {
  return callStatic<ReviewsSummaryResponse>(
    '/sitedata/{siteKey}/{sku}/d/review/summary/{locale}',
    parameters,
    ['sku']
  )
}

export default { reviewsSummary }
